<template>
  <div class="">
      <template v-if="step === 0 && !submitSuccess">
        <Modal :is-open="true" :showBackButton="false" modelPopupClass="tw-max-w-3xl" :showCloseButton="false">
            <div class="tw-text-secondary tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica">
                <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
                    {{ type === 'estimate'? 'SEND ESTIMATE': 'SEND QUOTE'}}
                </h2>
                <p v-if="type === 'estimate'">
                    Estimates are a great tool to speed up your quoting process. For instance, you 
                    can quickly give customers a “rough price” over the phone based on “rough 
                    measurements” they give you. The difference between an Estimate and a Quote 
                    is that an Estimate is just a “ball park figure” and a Quote is your “final price” 
                    based on a site visit and check measure.
                </p>   

                <div v-if="type === 'quote'">
                    <p >
                        A Quote is the preferred selection if you have completed a site visit and check 
                        measure or when you are quoting off plans. 
                    </p> 
                    <p >
                        The difference between an Estimate and a Quote is that an Estimate is just a 
                        “ball park figure” and a Quote is your “final price”.
                    </p> 
                </div>

                      
            </div>
            <template v-slot:footer>
                <div class="tw-mt-4 tw-flex tw-space-x-4">
                    <button @click="$emit('onClose')" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
                        <svg-icon name="solid/step-backward"/> <span class="tw-ml-2">BACK</span>
                    </button>

                    <button @click="step = 1" class="btn btn_transparent tw-m-0 tw-flex tw-items-center">
                        <svg-icon name="solid/step-forward"/> <span class="tw-ml-2">NEXT</span>
                    </button>
                </div>
            </template>
        </Modal>
      </template>

      <template v-if="step === 1 && !submitSuccess">
        <Modal :is-open="true" :showBackButton="false" modelPopupClass="tw-max-w-3xl">
            <div class="tw-text-secondary tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica">
                <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
                    {{ type === 'estimate'? 'LET’S SEND YOU THE ESTIMATE!': 'LET’S SEND YOU THE QUOTE!'}}
                </h2>
                <p v-if="type === 'estimate'">
                    Please fill the form below so our portal can send you the estimate. You will 
                    receive 2 different emails. The first one will be what your potential client (Named 
                    John Smith) would receive. The second email is what you will receive when John 
                    Smith approves the estimate.
                </p>       
                <p v-else>
                    Please fill the form below so our portal can send you the quote. You will receive 
                    2 different emails. The first one will be what your potential client (Named John 
                    Smith) would receive. The second email is what you will receive when John 
                    Smith approves the quote.
                </p> 

                <form class="form">

                    <div class="tw-grid tw-grid-cols-6 tw-gap-6">
                        <div class="tw-col-span-6 sm:tw-col-span-3">
                            <input type="text" class="focus:tw-border-secondary focus:tw-ring-secondary pristine sm:tw-text-sm touched tw-block tw-border tw-border-primary tw-border-solid tw-mt-1 tw-pt tw-px-3 tw-py-2 tw-shadow-sm tw-w-full"
                                    name="name"
                                    v-model="name"
                                    placeholder="Your Name*"
                                    v-validate="{required: true}"
                            >
                            <span class="form__error">{{ errors.first('name') }}</span>
                        </div>

                         <div class="tw-col-span-6 sm:tw-col-span-3">
                            <input type="text" class="focus:tw-border-secondary focus:tw-ring-secondary pristine sm:tw-text-sm touched tw-block tw-border tw-border-primary tw-border-solid tw-mt-1 tw-pt tw-px-3 tw-py-2 tw-shadow-sm tw-w-full"
                                    name="Business Name"
                                    v-model="businessName"
                                    placeholder="Business Name*"
                                    v-validate="{required: true}"
                            >
                            <span class="form__error">{{ errors.first('Business Name') }}</span>
                        </div>

                        <div class="tw-col-span-6 sm:tw-col-span-3">
                            <input type="text" class="focus:tw-border-secondary focus:tw-ring-secondary pristine sm:tw-text-sm touched tw-block tw-border tw-border-primary tw-border-solid tw-mt-1 tw-pt tw-px-3 tw-py-2 tw-shadow-sm tw-w-full"
                                    name="Email"
                                    v-model="email"
                                    placeholder="Email*"
                                    v-validate="{required: true, email: true}"
                            >
                            <span class="form__error">{{ errors.first('Email') }}</span>

                        </div>

                        <div class="tw-col-span-6 sm:tw-col-span-3">
                            <input type="text" class="focus:tw-border-secondary focus:tw-ring-secondary pristine sm:tw-text-sm touched tw-block tw-border tw-border-primary tw-border-solid tw-mt-1 tw-pt tw-px-3 tw-py-2 tw-shadow-sm tw-w-full"
                                    name="Phone Number"
                                    v-model="phone"
                                    placeholder="Phone Number*"
                                    v-validate="{required: true}"
                            >
                            <span class="form__error">{{ errors.first('Phone Number') }}</span>

                        </div>
                    </div> 
                </form>
            </div>
            <template v-slot:footer>
                <div class="tw-mt-4 tw-flex tw-space-x-4">
                    <button @click="submit" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
                        <template v-if="type === 'estimate'">
                            <svg-icon name="solid/clipboard-list"/> <span class="tw-ml-2">SEND ESTIMATE</span>
                        </template>
                        <template v-else>
                            <svg-icon name="solid/tape"/> <span class="tw-ml-2">SEND QUOTE</span>
                        </template>
                    </button>
                </div>
            </template>
        </Modal>
      </template>

      <template v-if="submitSuccess">
        <Modal :is-open="true" :showBackButton="false" modelPopupClass="tw-max-w-3xl" :showCloseButton="false">
            <div class="tw-text-secondary tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica">
                <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
                    {{ type === 'estimate'? 'ESTIMATE SENT SUCCESSFULLY!': 'QUOTE SENT SUCCESSFULLY!'}}
                </h2>
                <div class="tw-space-y-3">
                    <p>
                        Your {{type}} has been sent successfully! It should arrive in your mailbox shortly. 
                        <span class="tw-text-primary tw-font-bold">Please note the prices shown are estimated retail prices</span>. If you would like to 
                        see wholesale prices and much more of what our portal has to offer, you can click 
                        the <span class="tw-text-primary tw-font-bold">SIGN UP</span> button. 
                    </p>
                    <p>
                        Alternatively, if you would like to find out more information about Starline’s dealer 
                        program, click the more information button.
                    </p>                    
                </div>   

                <div class="tw-mt-6 tw-flex tw-space-x-4">
                    <a href="https://portal.starlinesecurity.net.au/registration" class="tw-group">
                        <div class="tw-flex tw-flex-col tw-items-center tw-justify-end tw-w-28">
                            <svg-icon name="solid/pen-field" class="tw-text-primary tw-h-16 tw-transition-all group-hover:tw-text-opacity-80"/>
                            <p class="tw-text-secondary tw-text-center tw-mt-4 tw-transition-all group-hover:tw-text-opacity-80">I’m ready to Sign up!</p>
                        </div>
                    </a>

                    <a href="https://starlinesecurity.net.au/dealers" class="tw-group">
                        <div class="tw-flex tw-flex-col tw-items-center tw-justify-end tw-w-28">
                            <svg-icon name="solid/messages-question" class="tw-text-primary tw-h-16 tw-transition-all group-hover:tw-text-opacity-80"/>
                            <p class="tw-text-secondary tw-text-center tw-mt-4 tw-transition-all group-hover:tw-text-opacity-80">I need more info</p>
                        </div>
                    </a>                    
                </div>                      
            </div>
        </Modal>
      </template>
  </div>

</template>

<script>
import Modal from '@/components/modals/Generic'
export default {
    name: 'SendEstimate',
    props: ['type'], //estimate || quote
    components: {
        Modal
    },
    data() {
        return {
            step: 0,
            name: '',
            businessName: '',
            email: '',
            phone: '',
        }
    },
    computed: {
        quoteSent() {
            return this.$store.state['demoWizard'].quoteSent
        },
        estimateSent() {
            return this.$store.state['demoWizard'].estimateSent
        },
        submitSuccess() {
            return this.quoteSent || this.estimateSent
        }
    },
    methods: {
        async submit() {
            this.$validator.validate().then(valid => {
                if (!valid) return

                const orderId = this.$store.getters["orderPreview/id"]
                const data = {
                    name: this.name,
                    business_name: this.businessName,
                    email: this.email,
                    order_id: orderId,
                    action: this.type,
                    phone: this.phone,
                }

                this.$store.dispatch('demoWizard/sendEstimate', data)
                console.log('Send ', this.type) 
            });
        },
    }
}
</script>

<style scoped lang="scss">
    @import "../../../assets/scss/utils/vars";

    .form {

        width: 100%;

        &__input {
            border-color: black;
        }
        &__labelTitle {
            color: black;
        }

        &__row_absolute {
            position: absolute;
            z-index: 1;
            left: 2rem;
            right: 2rem;
            bottom: 20px;
            width: auto;
        }
    }

</style>
